import { DeviceType } from "../../enums";

/**
 *  Returns the web store URL for the Bitwarden browser extension based on the device type.
 *  @defaults Bitwarden download page
 */
export const getWebStoreUrl = (deviceType: DeviceType): string => {
  switch (deviceType) {
    case DeviceType.ChromeBrowser:
      return "https://vault.nas.jwjnhb.com/dl/#downloads-web-browser";
    case DeviceType.FirefoxBrowser:
      return "https://vault.nas.jwjnhb.com/dl/#downloads-web-browser";
    case DeviceType.SafariBrowser:
      return "https://vault.nas.jwjnhb.com/dl/#downloads-web-browser";
    case DeviceType.OperaBrowser:
      return "https://vault.nas.jwjnhb.com/dl/#downloads-web-browser";
    case DeviceType.EdgeBrowser:
      return "https://vault.nas.jwjnhb.com/dl/#downloads-web-browser";
    default:
      return "https://vault.nas.jwjnhb.com/dl/#downloads-web-browser";
  }
};
